import { render } from "./PropertyServicesValues.vue?vue&type=template&id=c0a38e08&scoped=true&ts=true"
import script from "./PropertyServicesValues.vue?vue&type=script&lang=ts"
export * from "./PropertyServicesValues.vue?vue&type=script&lang=ts"

import "./PropertyServicesValues.vue?vue&type=style&index=0&id=c0a38e08&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0a38e08"]])

export default __exports__